import { useEffect, useState } from 'react';

export const useWindowDimensions = () => {
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setInnerWidth(window.innerWidth);
    setInnerHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  /**
   * @param targetValue - the target value in pixels to compare against the innerWidth
   * @returns boolean - true if the innerWidth is greater than or equal to the target value
   */
  const matchesMinWidth = (targetValue: number) => {
    return innerWidth >= targetValue;
  };

  /**
   * @param targetValue - the target value in pixels to compare against the innerWidth
   * @returns boolean - true if the innerWidth is less than or equal to the target value
   */
  const matchesMaxWidth = (targetValue: number) => {
    return innerWidth <= targetValue;
  };

  /**
   * @param targetValue - the target value in pixels to compare against the innerHeight
   * @returns boolean - true if the innerHeight is greater than or equal to the target value
   */
  const matchesMinHeight = (targetValue: number) => {
    return innerHeight >= targetValue;
  };

  /**
   * @param targetValue - the target value in pixels to compare against the innerHeight
   * @returns boolean - true if the innerHeight is less than or equal to the target value
   */
  const matchesMaxHeight = (targetValue: number) => {
    return innerHeight <= targetValue;
  };

  return {
    matchesMaxHeight,
    matchesMinHeight,
    matchesMaxWidth,
    matchesMinWidth,
  };
};
